import { Link } from "react-router-dom";
import { getImagePrefix } from "../../../../../helpers";

const Logo: React.FC = () => {
  return (
    <Link to="/">
      <img
        src= {`${getImagePrefix()}images/logo.jpg`}
        alt="logo"
        style={{ width: "auto", height: "auto" }}
        className="inline-block md:!h-[4rem] md:!w-[4rem] mb:!h-[3.5rem] mb:!w-[3.5rem]"
      />
    </Link>
  );
};

export default Logo;
